import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';

import { ScannerTypeConstant } from '@app/core/_constant/scanner-type.constants';

@Component({
  selector: 'app-warehouse-scanner',
  templateUrl: './warehouse-scanner.component.html',
  styleUrls: ['./warehouse-scanner.component.scss'],
})
export class WarehouseScannerComponent {
  constructor(private router :Router) {}

  handleScanSuccess(data :any) :void {
    if (data.type === ScannerTypeConstant.RFQ) {
      this.router.navigate(['/warehouse-mobile-app/location-selection', data.id]);
    } else if (data.type === ScannerTypeConstant.LOCATION) {
      this.router.navigate(['/warehouse-mobile-app/sku-selection', data.id]);
    } else if (data.type === ScannerTypeConstant.ORDER_NOT_IN_PICKING) {
      this.router.navigateByUrl(
        `/shipping/posted-orders?warehouseGroup=${data.warehouseGroupId}&orderNumber=${data.orderNumber}`,
      );
    } else if (data.type === ScannerTypeConstant.ORDER_SHIPPED) {
      this.router.navigateByUrl(
        `/shipping/posted-orders?warehouseGroup=${data.warehouseGroupId}&orderNumber=${data.orderNumber}`,
      );
    } else if (data.type === ScannerTypeConstant.ORDER_PICKLIST_CREATED) {
      this.router.navigate(['/shipping/visual-picking', data.id]);
    } else if (data.type === ScannerTypeConstant.ORDER_PICKLIST_PICKED) {
      this.router.navigate(['/shipping/picklists', data.id]);
    }
  }
}
